<template>
    <div class="app-container" style="background-color: #f9fbff;">
        <div class="review-title-content">
            <div class="reasons-title">
                <h3>給湯器駆けつけ隊の口コミ</h3>
            </div>
        </div>
        <div class="card">
            <div class="review-content">
                <div class="review-header">
                    <div class="rating-point-box">
                        <img src="../../assets/google-review.png" alt="">
                        <span class="rating-stars">★★★★★</span>
                        <span class="rating-score">評価５</span>
                    </div>
                </div>
                <p class="review-content-text">
                    今回で、給湯器は多分４台目です
                    今まで、大きな名前のガス会社はたかいばかりで結局丸投げだったし
                    <span class="under-yellow">TVで有名な会社にも見積取りましが、とにかく安い！</span>
                </p>
                <p class="review-content-text">取替工事は、ずっと寄り添って見てましたがすごく丁寧でテキパキと作業を進めて行って、リモコンなどの説明もしっかりして頂きました
                    正直安かったので少し不安もありましたが、<span class="under-yellow">今回が今までで1番安かったです 本当ありがとうの一言です!!</span>
                </p>
                <p class="google-review">引用：Google口コミ</p>
            </div>

            <div class="review-content">
                <div class="review-header">
                    <div class="rating-point-box">
                        <img src="../../assets/google-review.png" alt="">
                        <span class="rating-stars">★★★★★</span>
                        <span class="rating-score">評価５</span>
                    </div>
                </div>
                <p class="review-content-text">給湯器交換を依頼した<span class="under-yellow">その日に駆けつけて、交換</span>してもらえました。<br>
                    価格も、電話で見積もってもらった時の価格から上がることはなく、しかも、<span class="under-yellow">何社から見積りを取りましたが、一番リーズナブル</span>でした。</p>
                <p class="review-content-text">交換工事に来てくださった方も、とても親切で丁寧な工事を行っていただきました。</p>
                <p class="review-content-text">ミズテックさんにお願いしてとても満足しています。<br>友人にもミズテックさんを薦めたいと思います。</p>
                <p class="google-review">引用：Google口コミ</p>
            </div>

            <div class="review-content">
                <div class="review-header">
                    <div class="rating-point-box">
                        <img src="../../assets/google-review.png" alt="">
                        <span class="rating-stars">★★★★★</span>
                        <span class="rating-score">評価５</span>
                    </div>
                </div>
                <p class="review-content-text">電話対応から迅速で、機器の選択、工事も丁寧かつ説明も分かりやすく、<span
                        class="under-yellow">電話連絡から半日も経たないうちに、給湯器が新しくなりました。</span></p>
                <p class="review-content-text">しかも<span
                        class="under-yellow">どこよりも安くて本当に助かりました。</span>雨のなかの作業、本当にありがとうございました。</p>
                <p class="google-review">引用：Google口コミ</p>
            </div>
        </div>
    </div>
</template>

<script setup>
</script>

<style scoped>
.app-container {
    background: #f9fbff;
    padding: 40px 20px;
}

.reasons-title {
    margin-bottom: 30px;
    text-align: center;
}

.reasons-title h3 {
    font-size: 1.4rem;
    font-weight: 800;
    margin: 0;
    line-height: 1.2;
    background: linear-gradient(90deg, #3f51b5, #3F51B5);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    position: relative;
    display: inline-block;
    padding-bottom: 10px;
}

.reasons-title h3::after {
    content: "";
    display: block;
    width: 80px;
    height: 4px;
    background: #3f51b5;
    margin: 12px auto 0;
    border-radius: 2px;
}

.card {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.review-content {
    background: #fff;
    padding: 25px 20px;
    border: 1px solid #eee;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.06);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    text-align: left;
}

.review-header {
    margin-bottom: 12px;
}

.rating-point-box {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #555;
}

.rating-stars {
    color: #ffc107;
    font-size: 18px;
    letter-spacing: 2px;
}

.rating-score {
    font-size: 18px;
    font-weight: bold;
    color: #d9534f;
}

.google-review {
    text-align: right;
    font-size: 0.7rem;
    padding-bottom: 0;
    margin-bottom: 0;
}

.review-header img {
    width: 60px;
    height: auto;
}

.review-content-text {
    font-size: 0.85rem;
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 600px) {
    .review-content-text {
        font-size: 0.9rem;
    }

    .google-review {
        font-size: 0.7rem;
    }

    .rating-point-box img {
        width: 20%;
    }

    .rating-stars,
    .rating-score {
        font-size: 0.9rem;
    }

    .reasons-title h3 {
        font-size: 1.5rem
    }

    .rating-stars {
        font-size: 1.2rem;
    }
}
</style>
